import { render, staticRenderFns } from "./TeaserObject.vue?vue&type=template&id=6a308050&"
import script from "./TeaserObject.vue?vue&type=script&lang=js&"
export * from "./TeaserObject.vue?vue&type=script&lang=js&"
import style0 from "./TeaserObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports